import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

// EXT-6470: the in-app stand-in for window.confirm/alert. A null cancelLabel
// makes it a one-button notice.
export type ConfirmDialogData = {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string | null;
};

@Component({
  selector: 'jfw-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  protected readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(
    MatDialogRef<ConfirmDialogComponent, boolean>,
  );

  protected readonly confirmLabel = this.data.confirmLabel ?? 'OK';
  protected readonly cancelLabel =
    this.data.cancelLabel === undefined ? 'Cancel' : this.data.cancelLabel;

  protected close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
